import { createSelector } from '@reduxjs/toolkit';
import { Store } from 'components/common/types/Store.types';

export const getDirectSalesStatus = createSelector(
  (state: Store) => state.dealManagement.directSales.state.status,
  (status) => status,
);
